import React from "react";
//import frota from "../../img/frota.png";
import "./style.css";
import { Link } from "react-router-dom";
import axios from "axios";
import io from "socket.io-client";

require("dotenv").config();
const urlSocket = process.env.REACT_APP_API_SOCKET;
const url = process.env.REACT_APP_API_TASK;
const urlPadrao = process.env.REACT_APP_URL_PADRAO;

const socket = io(urlSocket);
class NavBar extends React.Component {
  state = {
    quantSync: ""
  };
  componentDidMount() {
    socket.on("reconnect", msg => {
      this.rePostFormClient();
      this.rePostFormPop();
    });
  }


 

  logout = () => {
    console.log("post deslogar");
    const objForm = {
      uuid: localStorage.getItem("uuid"),
      token: localStorage.getItem("token")
    };
    window.indexedDB.deleteDatabase("toDoList");
    window.indexedDB.deleteDatabase("fcm_token_details_db");
    window.indexedDB.deleteDatabase("undefined");
    window.indexedDB.deleteDatabase("fcm_vapid_details_db");
    axios
      .post(
        `${url}/postLogout`,
        {
          objForm: objForm
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
      .then(response => {
        localStorage.setItem("uuid", "");
        localStorage.setItem("user", "");
        localStorage.setItem("token", "");
        localStorage.setItem("name", "");
        console.log("deslogado 2");
        window.location.href = urlPadrao + "/login";
      })
      .catch(function(error) {
        //console.log(error);
      });
  };

  render() {
    return (
      <React.Fragment>
        <nav className="navbar  navbar-light   colorMenu">
          <div className="divLogo">
            {this.props.wayLast ? (
              <React.Fragment>
                <Link to={`${this.props.wayLast}`}>
                  <img
                    src="https://gerencia.all.com.br/imagens/allnet.png"
                    align="left"
                    className="navbar-brand"
                    width="140"
                    alt="allnet"
                  />
                </Link>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Link to={`/task`}>
                  <img
                    src="https://gerencia.all.com.br/imagens/allnet.png"
                    align="left"
                    className="navbar-brand"
                    width="140"
                    alt="allnet"
                  />
                </Link>
              </React.Fragment>
            )}
          </div>

          <ul className="nav navMenu">
            <li className="nav-item dropdown ">
              <span
                className="nav-link "
                data-toggle="dropdown"
                href="#"
                aria-haspopup="false"
                aria-expanded="false"
              >
                <div className="menuDrop">
                  <center>
                    <span className="navbar-toggler-icon iconMenu" />
                  </center>
                </div>
              </span>

              <div className="dropdown-menu dropdown-menu-right">
                <span className="dropdown-item">
                  <Link to="/task"> Tarefa</Link>
                </span>
                <span className="dropdown-item">
                  <Link to="/taskhistory"> Histórico de Tarefas</Link>
                </span>
                <span className="dropdown-item">
                  <Link to="/check-list"> Check List</Link>
                </span>
               
                <div className="dropdown-divider" />

                <button
                  type="button"
                  className="btn btn-link dropdown-item"
                  onClick={() => this.logout()}
                >
                  Sair
                </button>

                {this.props.wayLast && (
                  <React.Fragment>
                    <div className="dropdown-divider" />
                    <span className="dropdown-item">
                      <Link to={`${this.props.wayLast}`}> Voltar </Link>
                    </span>
                  </React.Fragment>
                )}
              </div>
            </li>
          </ul>
        </nav>
      </React.Fragment>
    );
  }
}

export default NavBar;
